import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/services/common.service';
import { AuthService } from 'src/services/auth.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import Swal from 'sweetalert2';
import { Observable, Subject } from 'rxjs';
import * as moment from "moment";
import { Router } from '@angular/router';
// import 'datatables.net';
// import 'datatables.net-buttons';

@Component({
  selector: 'app-Report',
  templateUrl: './Report.component.html',
  styleUrls: ['./Report.component.css']
})
export class ReportComponent implements OnInit {
  // @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  @ViewChild('datatableElement', { static: false }) datatableElement: DataTableDirective;

  // dtOptions: DataTables.Settings = {};
  // exportX()
  // {
  //   this.datatableElement.dtInstance.
  // }
  persons: any = [];
  dtTrigger: Subject<any> = new Subject();
  constructor(private commonService: CommonService, private authService: AuthService, private router: Router) { }
  list: any[];
  isLogin= false;
  dtOptions: any = {};
 
  ngOnInit() {
    this.isLogin = this.loggedIn();

    let that = this;
    let createFrom = "AGW";
    this.dtOptions = {
          pagingType: "full_numbers",
      pageLength: 10,
      scrollCollapse: true,
      processing: true,
      destroy: true,
      scrollY: "50vh",
        ajax: (dataTablesParameters: any, callback: any) => { 
          that.commonService.GetData(createFrom).subscribe((response: any)=>{
            if(response.success === true)
            {
              that.list = response.data;
              callback({
                // recordsTotal: resp.recordsTotal,
                // recordsFiltered: resp.recordsFiltered,
                data: response.data
              });
              return callback;
           
              // this.dtTrigger.next(this.list);
            }
          })
        },
        columns: [
          
            // {  title: 'Agent Code', data: "agentCode" },
            {  title: 'Applicant', data: "agentName" },
            {  title: 'Company name', data: "customF2" },
            {  title: 'Mobile Phone', data: "mobilePhone" }, 
            {  title: 'Email', data: "email" },  
         
            {  title: 'Birthday', data: "birthday" ,    render: function (data: any, type: any, row: any, meta: any) {
              if (data === null || data === undefined || data === '') {
                return '';
              } else {
                return moment.utc(data).local().format('DD/MM/YYYY').toString();

              }
            } },
            {  title: 'Source', data: "customF1" },
            {  title: 'Address', data: "address1" },
            {  title: 'Registered  Code', data: "areaCode" },
            {  title: 'Notes', data: "customF3" },
 
            {  title: 'Created On', data: "createdOn",  render: function (data: any, type: any, row: any, meta: any) {
              if (data === null || data === undefined || data === '') {
                return '';
              } else {
                return moment.utc(data).local().format('DD/MM/YYYY HH:mm:ss').toString();

              }
          } },
          ],
        dom: 'Bfrtip',
        // Configure the buttons
        buttons: [
             'csv', 'excel', 'print'
        ]
    };

    // this.dtOptions = {
       
    //   pagingType: "full_numbers",
    //   pageLength: 10,
    //   scrollCollapse: true,
    //   processing: true,
    //   destroy: true,
    //   scrollY: "50vh",
    //   columns: [
    //     {  title: 'Agent Code', data: "agentCode" },
    //     {  title: 'Agent Name', data: "agentName" },
    //     {  title: 'Area Code', data: "areaCode" },
    //     {  title: 'Birthday', data: "birthday" },
    //     {  title: 'Mobile Phone', data: "mobilePhone" }, 
    //     {  title: 'Created On', data: "createdOn" },
 
    // ],
    // dom: 'Bfrtip',
    // buttons: [
    //   'copy',
    //   'print',
    //   'csv',
    //   'excel',
    //   'pdf'
    // ]
    // };
    // this.loadData();
   
  }
  ngAfterViewInit() {
    
  }
  loggedIn() {
    // SECURITY: login is now proven by a (non-expired) token, NOT by the mere
    // presence of an 'AgentUser' value in localStorage (the original auth-bypass bug).
    // Authoritative validation still happens server-side on each data API.
    return this.authService.isAuthenticated();
  }
  logout() {
    this.authService.clear();
    localStorage.removeItem('AgentUser');
    this.isLogin = false;
    this.router.navigate(['/']).then(()=>{
      window.location.reload();
    });
  }
  model: any = {};
  isNameFocus = false;
  isPassFocus = false;
  onFocus(txt: any)
  {
    let IdFocus = txt.id;
    let IdValue = txt.value;
    if(IdFocus === 'txtName' && IdValue ==='')
    {
       this.isNameFocus = !this.isNameFocus;
    }
    if(IdFocus === 'txtPassword' && IdValue ==='')
    {
       this.isPassFocus = !this.isPassFocus;
    }
     
  }
  login(username:string, pass:string)
  {
    // let username = this.model?.username;
    // let pass = this.model?.password;
     let canLogin= true;
    if(username==='' || username===undefined || username===null  )
    {
      canLogin= false;
      Swal.fire({title:'Login',text:  "Please input User Name", icon:'warning'});

    }
    if(pass==='' || pass===undefined || pass===null  )
    {
      canLogin= false;
      
      Swal.fire({title:'Login',text:  "Please input Password", icon:'warning'});
    }
    if( canLogin===true)
    {
      this.commonService.Login(username, pass).subscribe((response: any)=>{
        if(response.result === 0)
        {
          // SECURITY: store the auth token (this is what gates the UI now). BE must
          // return a signed, expiring token and validate it on every data API.
          this.authService.setToken(response.token);
          // AgentUser is kept ONLY for displaying the user's name/UI, never as an auth gate.
          localStorage.setItem('AgentUser', JSON.stringify(response.data));
          this.isLogin = true;
          this.router.navigate(['/report']).then(()=>{
            window.location.reload();
          });
    
        }
        else
        {
          //  Swal.fire('Login', response.errorMessage, 'warning');
          Swal.fire({title:'Login',text:  response.message, icon:'warning'});

        }
    }, error=>{
      console.log('error Login', error);
      // Swal.fire('Login', "Can't get data", 'error');
      Swal.fire({title:'Login',text:  "Can't get data", icon:'error'});
      
    })
      
    }
    
  }
  loadData() 
  {
    
    let createFrom = "";
    this.commonService.GetData(createFrom).subscribe((response: any)=>{
        if(response.success === true)
        {
          this.list = response.data;
          this.dtTrigger.next(this.list);
          // this.dtOptions = {
          //   pagingType: "full_numbers",
          //   pageLength: 10,
          //   scrollCollapse: true,
          //   processing: true,
          //   destroy: true,
          //   scrollY: "50vh",
          //   columns: [
          //     { data: "" },
          //     { data: "index" },
          //     { data: "firstname" },
          //     { data: "lastname" }
          //   ],
          //   columnDefs: [
          //     {
          //       width: "10% !important;",
          //       targets: 0,
          //       searchable: false,
          //       orderable: false,
          //       className: "dt-body-center"
          //     }
          //   ]
          // };
          // const dataUrl =
          //   "https://raw.githubusercontent.com/l-lin/angular-datatables/master/demo/src/data/data.json";
      
          // this.http.get(dataUrl).subscribe(response => {
          //   this.persons = response.data;
          //   this.dtTrigger.next();
          // });
          
        
        }
        else
        {
          //  Swal.fire('Get Agent Report', response.errorMessage, 'warning');
          Swal.fire({title:'Get Agent Report',text:  response.message, icon:'warning'});

        }
    }, error=>{
      console.log('error Agent Report', error);
      
      Swal.fire({title:'Get Agent Report',text:  "Can't get data", icon:'error'});
      
    })
  }
}
